<template>
  <div class="container">
    <div class="mds-header mds-header--level-3 mre-padding">
      <h2 class="mds-header__title">Page not Found</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style>
.container {
  margin-top: 82px;
  width: 620px;
  margin-left: auto;
  margin-right: auto;
  height: 500px;
}
.mre-padding {
  padding: 32px;
}
</style>
